import React from "react"
import "./layout.scss"

import HeaderSimple from './headersimple/headersimple'
import FooterSimple from './footersimple/footersimple'
import WhatsappFloat from '../components/whatsapp-float/whatsapp-float'


const LayoutLanding = ({ className, headerProps, footerProps, children }) => {
  return (
    <>
      <div className={className}>
        <HeaderSimple properties={headerProps}></HeaderSimple>
        {children}
        <FooterSimple properties={footerProps}></FooterSimple>
      </div>
      <WhatsappFloat />
    </>
  )
}

export default LayoutLanding